// @constants
const { HYPHEN } = require('constants/index');

const valueHelper = {
    valueOrHyphen(value) {
        return value != null ? value : HYPHEN;
    },

    conditionalValueOrHyphen(condition, value){
        return condition ? value : HYPHEN;
    }
};

module.exports = valueHelper;
